module.exports = __webpack_public_path__ + "static/contact-image-2_m-dadd55d0773b205685b672e389d8a253.jpg";